import React from 'react';

const Achievements = () => {
    return (
        <div className='text-white'>
            <div className='backdrop-blur bg-white/20 w-4/5 sm:max-w-5xl mx-auto my-4 px-2 py-2 h-auto'>
                <h1 className='text-center p-2 font-bold text-3xl my-2'>
                    Achievements
                </h1>
                <div className='mx-auto max-w-3xl text-center'>
                    coming soon
                    {/* <ImageGallery items={items} /> */}
                </div>
            </div>
        </div>
    );
};

export default Achievements;
